module.exports = __webpack_public_path__ + "pc/static/img/notice.32e30480.png";